import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

import { AppState } from 'services/types';
import { OnlyMyTimesheetsCheckboxState } from './types';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectOnlyMyTimesheetsCheckbox = (
    state: AppState
): OnlyMyTimesheetsCheckboxState => state.onlyMyTimesheetsCheckbox;

const makeSelectOnlyMyTimesheetsCheckboxValue = (field: string): any =>
    createDeepEqualSelector(
        selectOnlyMyTimesheetsCheckbox,
        (onlyMyTimesheetsCheckboxState: any) =>
            onlyMyTimesheetsCheckboxState &&
            onlyMyTimesheetsCheckboxState[field]
    );

export {
    selectOnlyMyTimesheetsCheckbox,
    makeSelectOnlyMyTimesheetsCheckboxValue
};
